import axios from 'axios' // import axios
// import router from '@/router/router'
import store from '@/store/store'
import utils from '@/utils/utils'
import qs from 'qs'

var call = function(option = {url:'', method:'post', data:{}, headers:{}}){
  console.log("core.js <call>", option);
  option.headers.appVersion = utils.nativeCom.getUserAgentValue("appVersion");
  // option.headers["Access-Control-Allow-Methods"] = "GET,PUT,POST,DELETE,OPTIONS";
  // option.headers["Access-Control-Allow-Headers"] = "Content-Type, Authorization, Content-Length, X-Requested-With";

  return new Promise(function(resolve, reject){
    axios({
      url: option.url,
      method: option.method,
      data: qs.stringify(option.data),
      headers: option.headers,
      withCredentials: true,
      // paramsSerializer: data => {
      //   return qs.stringify(data)
      // }
    }).then((response) => {  
        console.log("core.js <call.response> ", response);

        var data = response.data;
        var rt = data.rt;
        if(rt == 'success')   {
          resolve(data.data);
        } else if(rt == 'unauthorized' || rt == 'auth_token_expired' || rt == 'session_expired') {
          // alert("세션이 만료되었습니다. 다시 로그인 해주세요.");
          store.dispatch("clearUser");
          // utils.nativeIf.outbound.setAppDB("authToken", "");
          // router.push({name:'login'}).catch(function() {});
          utils.nativeIf.outbound.sessionExpired();
        } else {
          reject(data);    
        }            
      })
    .catch(function(error) {
      var errorName = error.name;
      if(errorName === 'Error') {
        alert("네트워크 연결 중 오류가 발생했습니다. 다시 시도해주세요.")
      } else {
        var data = {};
        data.rt = errorName;
        data.rtMsg = error.message;
        reject(data);
      }
    });
  }); 
}



export default {
  call
}

